import React from 'react';
import { Row, Col, FormGroup, Label, Input, Card, CardHeader, CardBody } from 'reactstrap';
import { Address } from '../../models/Address.interface';

interface ContractorInformationFormProps {
  contractorName: string;
  setContractorName: (value: string) => void;
  contractorLicense: string;
  setContractorLicense: (value: string) => void;
  contractorAddress: Address;
  setContractorAddress: (address: Address) => void;
  contractorPhone: string;
  setContractorPhone: (value: string) => void;
  contractorEmail: string;
  setContractorEmail: (value: string) => void;
}

const ContractorInformationForm: React.FC<ContractorInformationFormProps> = ({
  contractorName,
  setContractorName,
  contractorLicense,
  setContractorLicense,
  contractorAddress,
  setContractorAddress,
  contractorPhone,
  setContractorPhone,
  contractorEmail,
  setContractorEmail,
}) => {
  return (
    <Card className="mt-4 mb-4">
      <CardHeader>
        <h5 className="mb-0">Contractor Information</h5>
      </CardHeader>
      <CardBody>
        <Row>
          <Col md={6}>
            <FormGroup>
              <Label for="contractorName">Contractor Name</Label>
              <Input
                type="text"
                name="contractorName"
                id="contractorName"
                value={contractorName}
                onChange={(e) => setContractorName(e.target.value)}
                required
              />
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup>
              <Label for="contractorLicense">Contractor License</Label>
              <Input
                type="text"
                name="contractorLicense"
                id="contractorLicense"
                value={contractorLicense}
                onChange={(e) => setContractorLicense(e.target.value)}
                required
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <FormGroup>
              <Label for="contractorAddress">Address</Label>
              <Input
                type="text"
                name="contractorAddress1"
                id="contractorAddress1"
                value={contractorAddress.address1}
                onChange={(e) => setContractorAddress({ ...contractorAddress, address1: e.target.value })}
                required
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={4}>
            <FormGroup>
              <Label for="contractorCity">City</Label>
              <Input
                type="text"
                name="contractorCity"
                id="contractorCity"
                value={contractorAddress.city}
                onChange={(e) => setContractorAddress({ ...contractorAddress, city: e.target.value })}
                required
              />
            </FormGroup>
          </Col>
          <Col md={4}>
            <FormGroup>
              <Label for="contractorState">State</Label>
              <Input
                type="text"
                name="contractorState"
                id="contractorState"
                value={contractorAddress.state}
                onChange={(e) => setContractorAddress({ ...contractorAddress, state: e.target.value })}
                required
              />
            </FormGroup>
          </Col>
          <Col md={4}>
            <FormGroup>
              <Label for="contractorZip">ZIP Code</Label>
              <Input
                type="text"
                name="contractorZipCode"
                id="contractorZipCode"
                value={contractorAddress.zipCode}
                onChange={(e) => setContractorAddress({ ...contractorAddress, zipCode: e.target.value })}
                required
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <FormGroup>
              <Label for="contractorPhone">Phone</Label>
              <Input
                type="tel"
                name="contractorPhone"
                id="contractorPhone"
                value={contractorPhone}
                onChange={(e) => setContractorPhone(e.target.value)}
                required
              />
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup>
              <Label for="contractorEmail">Email</Label>
              <Input
                type="email"
                name="contractorEmail"
                id="contractorEmail"
                value={contractorEmail}
                onChange={(e) => setContractorEmail(e.target.value)}
                required
              />
            </FormGroup>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
};

export default ContractorInformationForm;